/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const browser_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M1 6.25h22M7.75 7v15M2.25 2h19.5s1.5 0 1.5 1.5v17s0 1.5-1.5 1.5H2.25s-1.5 0-1.5-1.5v-17S.75 2 2.25 2Z"
    />
  </svg>
)
export default browser_medium
